import { ISupplier, ISupplierMap } from '../models/ISupplier';
import { IBlendTotalQuota } from '../models/IBlendTotalQuota';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'blendFilter'
})
export class BlendFilterPipe implements PipeTransform {

  /* ended up not using this, but I can filter out the suppliers in the blend from the supplier drop down with this. */
  transform(suppliers: ISupplier[], blend: IBlendTotalQuota): ISupplier[] {
    if (!suppliers) return [];
    if (!blend) return suppliers;
    return suppliers.filter(it => {
      return blend.members.find(x => x.id === it.supplierId) === undefined;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/supplier-blend-filter-pipe.pipe.ts